import { ScriptProcessingResult, SpeakableScriptPartType } from '../../../types/asset/script.types.ts';

import { BaseScriptsProcessor } from './base-scripts-processor.ts';

/**
 * This processor is used to process the regular part of a script: "Regular Text"
 */
export class RegularProcessor extends BaseScriptsProcessor {
  public process(part: string): ScriptProcessingResult {
    return { parts: [{ text: this.finalizeScript(part), type: SpeakableScriptPartType.Text }], processed: true };
  }

  private finalizeScript(script: string): string {
    let result = script;

    // Replace \( and ) with quotes
    result = result.replace(/\\\(/g, '"').replace(/\)/g, '"');

    // Remove non-alphanumeric chars from start
    result = result.replace(/^[^a-zA-Z0-9]+/, '');

    // Remove non-alphanumeric chars from end except punctuation and >
    // Note: > may be at the end when pronunciation uses <phoneme> tags
    result = result.replace(/[^a-zA-Z0-9\p{P}>]+$/u, '');

    return result;
  }
}
